import ApiService from "../ApiService";

const PatientService = {
  getByDocument(documentTypeId, document) {
    return ApiService.get(
      `patient/by-document?documentTypeId=${documentTypeId}&document=${document}`
    );
  },
  async prioritizedPatient(identification, identificationType) {
    return ApiService.get(
      `prioritized-patient?identification=${identification}&identificationType=${identificationType}`
    )
  }
}

export default PatientService
